import React, { Component } from 'react'
import { connect } from 'react-redux'

import CharacterDropIn from '../components/CharacterDropIn'
import MessageList from '../components/MessageList'
import BottomNav from '../components/BottomNav'
import EventListener from '../components/EventListener'
import WebSocket from '../components/WebSocket'
import { addMessage } from '../actions/actions'

import { Map, Market, Popup, TileLayer } from 'react-leaflet'

class TestBed extends Component {
    constructor(props) {
        super(props)
        this.DEFAULT_VIEWPORT = {
            center: [38.534257, -78.646908],
            zoom: 15,
        }
        this.state = {
            viewport: this.DEFAULT_VIEWPORT
        }
        this.source = new EventSource('https://stream.wikimedia.org/v2/stream/recentchange')
        this.source.addEventListener('message', (e) => {
            let user = JSON.parse(e.data).user
        })
    }

     render() {
         return (
            <div>
                <nav className="pt-navbar">
                    <div className="pt-navbar-group pt-align-left">
                        <div className="pt-navbar-heading">
                            <b><CharacterDropIn value={'Jamal Mahboob: Test Bed'} /></b>
                        </div>
                    </div>
                </nav>
                <div>
                    <Map position={this.position}
                        onClick={this.onClickReset}
                        onViewportChanged={this.onViewportChanged}
                        viewport={this.state.viewport}>
                        <TileLayer
                            url='https://api.mapbox.com/styles/v1/jamalmahboob/cj44ptn8f9vt02sk47gobybp9/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiamFtYWxtYWhib29iIiwiYSI6ImNpeTIweGxuYTAwMDkycWxhaDN1YmZndWYifQ.ZqVbtaAFaZvyQxq030_csQ'
                        />
                    </Map>
                </div>
                <div style={{position:'fixed',top:'75px',zIndex:'1001',right:'25px',width:'200px'}}>
                    <MessageList store_value='messages'/>
                </div>
                <div style={{position:'fixed',top:'75px',zIndex:'1001',right:'235px',width:'200px'}}>
                    <MessageList store_value='firewalld'/>
                </div>
                <EventListener />
                <WebSocket />
                <BottomNav />
            </div>
        )
    } 
}

const mapStateToProps = (state) => {
    return {}
}

export default connect(mapStateToProps)(TestBed)



// WEBPACK FOOTER //
// ./src/containers/TestBed.js